import { Injectable } from '@angular/core';
import { PxdAgGridCheckboxRendererReadOnly } from '@app/shared/aggrid/pxd-ag-grid-cell-renderers';
import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from '@app/shared/aggrid/pxd-ag-grid-options';
import { PxdAgGridSelectEditorComponent } from '@app/shared/aggrid/pxd-ag-grid-select-editor';
import { RowSelectionOptions } from 'ag-grid-community';

export class FindProjectScheduleGridOptions implements PxdAgGridOptions {
  enableCharts = true;
  cellSelection = true;
  rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'never';
  rowSelection: RowSelectionOptions = { mode: 'singleRow', checkboxes: false, enableClickSelection: true };
  editType: 'fullRow' = 'fullRow';
  defaultColDef = PxdAgEditGridDefaultColumnDef;
  statusBar = PxdAgGridStatusBarOptions;
  sideBar = PxdAgGridSideBarOptions;
  columnTypes = PxdAgGridColumnTypes;
  components = null;
  columnDefs = [];
}

@Injectable()
export class FindProjectScheduleGridOptionsService {
  public findProjectScheduleGridOptions: FindProjectScheduleGridOptions = new FindProjectScheduleGridOptions();

  public constructor() {
    this.findProjectScheduleGridOptions.columnDefs = this.columnDefs;
    this.findProjectScheduleGridOptions.components = { pxdAgGridSelectEditor: PxdAgGridSelectEditorComponent, pxdAgGridCheckboxRendererReadOnly: PxdAgGridCheckboxRendererReadOnly };
  }

  private columnDefs = [
    { field: 'ScheduleId', headerName: 'ScheduleId', hide: false, editable: false },
    {
      field: 'SSNs', headerName: 'Schedule SSNs', editable: false
    },
    { field: 'ScheduleTemplateNameId', headerName: 'ScheduleTemplateNameId', editable: false },
    { field: 'ScheduleProjectTypeId', headerName: 'ScheduleProjectTypeId', editable: false }
  ];
}